import { endpoints } from './endpoints';
import { httpClient } from './http-client';

/** Shape of GET /api/v1/admin/me (backend MeResponse). Status/levels are uppercase enum codes.
 *  v9 (DEC-DB-PK-BIGINT-001): id is BIGINT UNSIGNED → number on the wire. */
export interface Me {
  id: number;
  email: string;
  name: string;
  isRoot: boolean;
  status: string;
  roles: string[];
  permissions: Record<string, string>; // category -> NO_PERMISSION | READ | WRITE
}

interface ApiEnvelope<T> {
  data: T;
}

/** Fetch the current authenticated admin's profile + merged permissions. Requires a valid token. */
export async function fetchMe(): Promise<Me> {
  const res = await httpClient.get<ApiEnvelope<Me>>(endpoints.auth.me);
  const me = res.data?.data;
  // Contract is `{ data: Me }`. A null/undefined body (wrong envelope, SPA
  // fallback HTML, …) would crash every consumer that reads `me.permissions`
  // / `me.roles`; surface it as a load error instead.
  if (me == null) {
    throw new Error('알 수 없는 오류가 발생했습니다.');
  }
  // `roles` is consumed downstream via `.map` / `.length`. If the backend sends
  // it present-but-not-an-array (wrong shape from the half-built BE), normalize
  // to `[]` so those array ops don't throw "roles.map is not a function".
  if (!Array.isArray(me.roles)) {
    me.roles = [];
  }
  return me;
}
